import React from 'react'
import { useSlate } from 'slate-react'
import { IconMaps } from '@ow/icons'
import BaseButton from './BaseButton'
import { isMarkActive, toggleMark } from '../utils/util'

// 行内按钮 加粗/斜体/下划线..
const MarkButton = function ({ format, icon, tip }) {
  const editor = useSlate()
  return (
    <BaseButton
      tip={tip}
      active={isMarkActive(editor, format)}
      onMouseDown={(event) => {
        event.preventDefault()
        toggleMark(editor, format)
      }}
    >
      <IconMaps
        type={icon}
        width={18}
        height={18}
        // 暂时先用主题色，等梓芸将icon修改好之后再用二进制色值
        fill={isMarkActive(editor, format) ? 'dark' : 'gray'}
        // fill={isMarkActive(editor, format) ? '#000' : '#ccc'}
      />
    </BaseButton>
  )
}

export default MarkButton
